import { GET_USER_INFO_FROM_MILES, GET_USER_MILES, GET_MONTHLY_RANKING, GET_PAST_MONTHLY_RANKING, GET_USER_MILES_HISTORY, BALANCE_INQUIRY_API, UNLINK_CARD, LINK_KFC_CARD, ERROR_MSG, IS_LOADING, GET_USER_MILES_CURRENT_HISTORY, GET_USER_MILES_PAST_HISTORY, GET_RANKING_View, GET_LAST_MONTH_RANKING_View, STORE_RETURNED_ACCOUNT_ID, NAVIGATE_TO_EXTERNAL_WEBSITE, GET_OVERALL_RANKING, LINK_CARD_STATUS, CLEAR_KFC_LINKING_DATA, GET_USER_OVERALL_RANKING, } from '../../constants';
import App from '../../App';
export function getUserInfoFromUserMiles() {
    return {
        type: GET_USER_INFO_FROM_MILES,
    };
}
export function getUserMiles(payload) {
    return {
        type: GET_USER_MILES,
        payload,
    };
}
export function getUserMonthlyRanking(payload) {
    return {
        type: GET_MONTHLY_RANKING,
        payload,
    };
}
export function getUserPastMonthlyRanking(payload) {
    return {
        type: GET_PAST_MONTHLY_RANKING,
        payload,
    };
}
export function getRankingView(payload) {
    return {
        type: GET_RANKING_View,
        payload,
    };
}
export function getOverallRanking(payload) {
    return {
        type: GET_OVERALL_RANKING,
        payload,
    };
}
export function getUserOverallRanking(payload) {
    return {
        type: GET_USER_OVERALL_RANKING,
        payload,
    };
}
export function getLastMonthRankingView(payload) {
    return {
        type: GET_LAST_MONTH_RANKING_View,
        payload,
    };
}
export function getUserMilesHistory(payload) {
    return {
        type: GET_USER_MILES_HISTORY,
        payload,
    };
}
export function getUserMilesCurrentHistory(payload) {
    return {
        type: GET_USER_MILES_CURRENT_HISTORY,
        payload,
    };
}
export function getUserMilesPastHistory(payload) {
    return {
        type: GET_USER_MILES_PAST_HISTORY,
        payload,
    };
}
export function balanceInquiryAPI(payload) {
    return {
        type: BALANCE_INQUIRY_API,
        payload,
    };
}
export function unlinkCard(payload) {
    return {
        type: UNLINK_CARD,
        payload,
    };
}
export function linkCard(payload) {
    return {
        type: LINK_KFC_CARD,
        payload,
    };
}
export function linkCardStatusMsg(payload) {
    return {
        type: LINK_CARD_STATUS,
        payload,
    };
}
export function setErrorMsg(payload) {
    return {
        type: ERROR_MSG,
        errorMsg: payload,
    };
}
export function setIsLoading(payload) {
    return {
        type: IS_LOADING,
        isLoading: payload,
    };
}
export function storeReturnedAccountId(payload) {
    return {
        type: STORE_RETURNED_ACCOUNT_ID,
        pontaAccountID: payload,
    };
}
export const clearKfcLinkingData = () => ({
    type: CLEAR_KFC_LINKING_DATA,
    payload: {
        clearLinkingData: {},
    },
});
export const navigateToExternalWebsite = (pontaAccountID) => {
    let externalURL = 'https://st.ponta.jp/front/LWAS900/SLWAS900110.htm?a={siteAuthentication}&p=link-processing';
    if (App.envVars?.authParams?.appEnvironment === 'DEV') {
        externalURL = externalURL.replace('{siteAuthentication}', '3c54fafc8d8532e6a12e646d8ea5dbeb');
    }
    else {
        externalURL = externalURL.replace('{siteAuthentication}', 'e7b69a066f073338d94e177c1d12b0d4');
    }
    return {
        type: NAVIGATE_TO_EXTERNAL_WEBSITE,
        payload: {
            externalURL,
        },
        pontaAccountID,
    };
};
